import React, { FC } from 'react'
import { socialImpactStrings } from 'common/strings/social-impact-strings'
import classNames from 'classnames'
import useWindowSize from 'components/util/useWindowSize'
import imageResize from 'project/image-proxy-web'

type TalkToUsType = {}

const TalkToUs: FC<TalkToUsType> = ({}) => {
  const size = useWindowSize()
  return (
    <div className='container text-center mt-xxl-50 mt-lg-21 mt-14'>
      <div className='row'>
        <div className='col-lg-8 mx-auto'>
          <p className={'h4 h4--small text-bold mb-lg-3 mb-6'}>
            {socialImpactStrings.strengthIsOurDiversity}
          </p>
          <h2
            className={classNames(
              'text-bold mb-lg-6 mb-6',
              size.isLgOrHigher ? 'fs-fluid-36-80 lh-105' : 'h3 px-4',
            )}
            dangerouslySetInnerHTML={{
              __html: socialImpactStrings.talkToUs,
            }}
          />
          <a
            href={`mailto:${socialImpactStrings.email}`}
            className='text-xxxl--large2 text-link text-bold color-black1 text-decoration-none'
          >
            {socialImpactStrings.email}
          </a>
          <img
            loading='lazy'
            src={imageResize(require('public/images/logos/hm-logo-white.svg'))}
            alt={'Logo'}
            width={size.isLgOrHigher ? 532 : 304}
            className={'d-block mx-auto mt-lg-19 mt-8'}
          />
        </div>
      </div>
    </div>
  )
}

export default TalkToUs
